import auth from './auth';
import ui from './ui';

const actions = {auth, ui};

export default actions;
